import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useT } from "../i18n/LanguageContext";

export const FAQ = () => {
  const { t } = useT();
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-white border-y border-[var(--al-line)]">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="al-tag">{t.faq.tag}</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight">
            {t.faq.h2a}<span className="al-grad-text">{t.faq.h2b}</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {t.faq.items.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="al-card px-6 border-b-0">
              <AccordionTrigger className="font-display font-semibold text-left text-lg py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
